module.exports = __webpack_public_path__ + "static/telling-36a94e2701262519d82b349212f9a2d0.png";